import moment from 'moment-timezone'
import { PropsWithChildren, FC } from 'react'
import { Steps } from 'antd'
import { CheckOutlined } from '@ant-design/icons'

import Text from '~/core/Text'
import styles from '../styles.css'

import DescriptionContent from './ProgressBarDescription'
import { getStagesOfProgressBarStep, getCurrentMilestoneStage } from './logic'
import { ProgressBarParameters, ProgressDataType } from './types'

const { Step } = Steps

type JobStatusProgressBarPropsType = {
    progressData: ProgressDataType[]
}

const JobStatusProgressBar: FC<
    PropsWithChildren<JobStatusProgressBarPropsType>
> = props => {
    const { progressData } = props
    const currentStageIndex = getCurrentMilestoneStage(progressData) || null
    let isCurrentStageDelayed = false
    const currentData = currentStageIndex
        ? progressData[currentStageIndex]
        : undefined

    const getStageStatus = (
        stages: ProgressBarParameters,
        stageIndex: number,
    ) => {
        if (stages.isDelayed && currentStageIndex === stageIndex) {
            return 'process'
        } else if (stages.isDelayed) {
            return 'error'
        } else if (currentStageIndex === null) {
            return 'finish'
        }

        return undefined
    }

    if (
        currentData?.committedDate &&
        moment(moment()).isAfter(currentData.committedDate)
    ) {
        isCurrentStageDelayed = true
    }

    return (
        <Steps
            className={
                isCurrentStageDelayed
                    ? styles.delayedProgressBarStyles
                    : styles.progressBarStyles
            }
            labelPlacement="vertical"
            size="small"
            current={currentStageIndex || undefined}
            percent={70}
            responsive
        >
            {progressData.map((progress, index) => {
                const stages = getStagesOfProgressBarStep(progress)

                return (
                    <Step
                        key={index}
                        data-test-target={progress.milestone}
                        title={
                            <Text
                                style={{ marginBottom: '6px' }}
                                fontSize="14px"
                            >
                                {progress.milestoneTitle}
                            </Text>
                        }
                        description={
                            <DescriptionContent
                                description={progress}
                                stages={stages}
                            />
                        }
                        progressDot={() =>
                            stages.isComplete && <CheckOutlined />
                        }
                        status={getStageStatus(stages, index)}
                    />
                )
            })}
        </Steps>
    )
}

export default JobStatusProgressBar
